// "Local" or "Staging" chip outside production (FR-038; US5-5); nothing in production.
import { StyleSheet, View } from "react-native";

import { type AppEnv, ConfigError, readPublicConfig } from "@/config";
import { makeStyles } from "@/theme/makeStyles";
import { Text } from "@/ui/Text";

const LABEL: Record<AppEnv, string | null> = {
  local: "Local",
  staging: "Staging",
  production: null,
};

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    badge: {
      alignSelf: "flex-start",
      margin: t.space.xs,
      paddingHorizontal: t.space.smd,
      paddingVertical: t.space.xxs / 2,
      borderRadius: t.radius.pill,
      backgroundColor: t.color.envBadge,
    },
  }),
);

function currentEnv(): AppEnv | null {
  try {
    return readPublicConfig().appEnv;
  } catch (error) {
    if (error instanceof ConfigError) return null;
    throw error;
  }
}

export function EnvBadge({ appEnv }: { appEnv?: AppEnv }) {
  const styles = useStyles();
  const env = appEnv ?? currentEnv();
  const label = env ? LABEL[env] : null;
  if (!label) return null;
  return (
    // A labelled landmark, so axe's region rule holds on every page (2026-10-06).
    <View
      style={styles.badge}
      testID="env-badge"
      role="complementary"
      aria-label="Environment"
    >
      <Text size="xs" weight="semiBold">
        {label}
      </Text>
    </View>
  );
}
